import { get } from 'lodash-es';

/**
 * Resolves the price to display on inventory cards.
 *
 * Priority order:
 *  1. Lease monthly payment (`prices.estimateLeasePromise.monthlyPayment`) when `displayLeaseMonthlyPayment` is true.
 *  2. Loan monthly payment (`prices.loan.payment`) when `displayLoanMonthlyPayment` is true.
 *  3. `prices.advertisedPrice`, or `0` if not present.
 *
 * @param {object}  params
 * @param {object}  params.prices                     - Prices object from the inventory record.
 * @param {number}  [params.prices.advertisedPrice]   - Dealer-advertised price.
 * @param {object}  [params.prices.estimateLeasePromise] - Lease estimate object.
 * @param {number}  [params.prices.estimateLeasePromise.monthlyPayment] - Lease monthly payment amount.
 * @param {object}  [params.prices.loan]              - Loan estimate object.
 * @param {number}  [params.prices.loan.payment]      - Loan monthly payment amount.
 * @param {boolean} params.displayLeaseMonthlyPayment - When true, returns the lease monthly payment instead of base price.
 * @param {boolean} params.displayLoanMonthlyPayment  - When true, returns the loan monthly payment instead of base price.
 * @returns {number} The resolved display price, or `0` if the price cannot be determined.
 */
export function resolveDisplayPrice({ prices, displayLeaseMonthlyPayment, displayLoanMonthlyPayment }) {
  if (displayLeaseMonthlyPayment) {
    return get(prices, 'estimateLeasePromise.monthlyPayment', 0);
  }

  if (displayLoanMonthlyPayment) {
    return get(prices, 'loan.payment', 0);
  }

  return get(prices, 'advertisedPrice', 0);
}
